<template>
	<div id="Bigcoffeegatheringdetails" class="centert">
		<div style="position: fixed;bottom: 5px;right: 50px;width: 50px;height: 50px;background-color: red;color: #FFF;z-index: 2;line-height: 50px;text-align: center;"
			@click="fha">
			返回
		</div>
<!--		&lt;!&ndash; 头标签 &ndash;&gt;-->
<!--		<dpubtop></dpubtop>-->
<!--		&lt;!&ndash; 中间 &ndash;&gt;-->
		<div class="Bigcoffdetails">
			<!-- 头部 -->
			<div class="pub_pub">
				<div class="pub_title">
					<div class="img_logo">
						<img src="../../../imges/lebiao/zjzk.png" alt="">
					</div>
					<div class="title_t">
						<div class="imhg_ti">
							<img src="../../../imges/lebiao/zjzk_font.png" alt="">
						</div>
						<div class="sm_t">
							<div style="float:left"><span>船舶</span><span style="color:#D7230C;">船型</span></div>
							<div class="sm_pub">船图上传</div>
						</div>
					</div>
				</div>
				<div style="width: 0px;height: 36px;border: 1px solid #ececec;float: left;">
					<!-- 中间线 -->
				</div>
				<div class="ckgd_dh">
<!--					<div class="sy">-->
<!--						<div class="sy_img">-->
<!--							<img src="../../../imges/details/sy.png" alt="">-->
<!--						</div>-->
<!--						<router-link class="sy_title" to="/" style="text-decoration: none;-->
<!--							">首页</router-link>-->
<!--					</div>-->
<!--					<div class="jt" style="margin-top: 0px;">-->
<!--						<img src="../../../imges/details/jt.png" alt="">-->
<!--					</div>-->
					<div class="name">船舶船型</div>
				</div>
			</div>
			<!-- 头部结束 -->
			<div class="top_bottom">
				<div class="top_bottom_T">
					<div class="dtiail_warp">
						<div class="dtiail_title" style="text-align: left;color: #000;font-weight: 600;">
							{{contents.title}}</div>
						<div style="width: 100%;height: 50px;">
							<span style="font-size: 14px;color: #9399a5;">造船公司：</span><span
								style="font-size: 14px;margin-left:10px;">{{contents.construction_unit}}</span><br />
							<span style="font-size: 14px;color: #9399a5;">设计单位：</span><span
								style="font-size: 14px;margin-left:10px;">{{contents.design_unit}}</span><br />
							<span style="font-size: 14px;color: #9399a5;">船舶业主：</span><span
								style="font-size: 14px;margin-left:10px;">{{contents.ship_owner}}</span>
						</div>
						<!-- 上传者信息 -->
						<!-- <div style="text-align: center;">
							<span>上传日期：{{getLocalTime(contents.create_time)}}</span>
							<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上传者：{{`${contents.uid}`.substring(0,1)}}&nbsp; *&nbsp;*
								&nbsp;{{`${contents.username}`.substring(3,4)}}</span>
							<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;阅读数：{{contents.view}}</span>
						</div> -->
						<!-- 内容渲染 -->
						<!-- <div class="cont_dtiail" style="height: 300px;" v-html="contents.content">

						</div> -->
						<div v-if="ktpa" style="height: 595px;width: 100%;margin-top: 25px;">
							<!-- <el-carousel height="150px">
								<el-carousel-item v-for="item in 4" :key="item">
									<h3 class="small">{{ item }}</h3>
								</el-carousel-item>
							</el-carousel> -->
							<img v-lazy=" 'http://admin.shipoe360.com/public/' + contents.picture"
								style="width: 100%;height: 100%;" alt="">
						</div>
						<div v-if="kspa" style="height: 595px;width: 100%;margin-top: 25px;">
							<video ref='video' :src="'http://admin.shipoe360.com/public/' +contents.video"
								controls="controls"
								style="clear:both;display:block;margin:auto;width: 100%;height: 590px;"></video>
							<!-- <img v-lazy=" 'http://admin.shipoe360.com/public/' + contents.picture" style="width: 100%;height: 100%;" alt=""> -->
						</div>
						<div v-if="kvra" style="height: 595px;width: 100%;margin-top: 25px;">
							<iframe width="100%" height="100%" :src="contents.vr_link"></iframe>
							<!-- <img v-lazy=" 'http://admin.shipoe360.com/public/' + contents.picture" style="width: 100%;height: 100%;" alt=""> -->
						</div>
						<div class="1"
							style="width: 100%;height: 100px;margin-top: 10px;text-align: center;color: #FFF;font-size: 15px;color: #FFF;font-weight: 600;padding-left: 40%;">
							<div v-if="contents.vr_link!=''"  @click="kvr"
								style="width: 50px;height: 90px;text-align: center;float: left;">
								<img src="./vr.png" style="width:100%;height:65px;" />
								<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;color: #000;font-weight: 400;">
									VR
								</div>
							</div>
							<div v-if="contents.video!=''"  @click="ksp"
								style="width: 50px;height: 90px;text-align: center;float: left;margin-left: 20px;">
								<img src="./sp.png" style="width:100%;height:65px;" />
								<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;color: #000;font-weight: 400;">
									视频
								</div>
							</div>
							<div v-if="contents.picture!=''"  @click="ktp"
								style="width: 50px;height: 90px;text-align: center;float: left;margin-left: 20px;">
								<img src="./tp.png" style="width:100%;height:65px;" />
								<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;color: #000;font-weight: 400;">
									图片
								</div>
							</div>
							<!-- <div v-if="contents.vr_link!=''" class="1"
								style="width: 50px;height: 65px;margin-top: 5px;float: left;line-height: 40px;"
								@click="kvr">
							</div> -->
							<!-- <div v-if="contents.video!=''" class="1"
								style="width: 50px;height: 65px;margin-top: 5px;float: left;line-height: 40px;margin-left: 20px;"
								@click="ksp">
								<img src="./sp.png" style="width:100%;height:100%;" />
							</div>
							<div v-if="contents.picture!=''" class="1"
								style="width: 50px;height: 65px;margin-top: 5px;float: left;line-height: 40px;margin-left: 20px;"
								@click="ktp">
								<img src="./tp.png" style="width:100%;height:100%;" />
							</div> -->
						</div>
						<div class="dtiail_title"
							style="text-align: left;color: #000;font-weight: 600;margin-top: 20px;">信息内容</div>
						<div style="width: 100%;height: 10px;border-bottom: 1px solid #f1f1f1;"></div>
						<div style="width: 100%;border-bottom: 1px solid #f1f1f1;" v-html="contents.content">

						</div>
						<div class="dtiail_title" style="text-align: left;color: #000;font-weight: 600;">船舶基本信息</div>
						<div style="width: 100%;height: 10px;border-bottom: 1px solid #f1f1f1;"></div>
						<div style="width: 100%;height: 200px;border-bottom: 1px solid #f1f1f1;">
							<div
								style="width: 20%;height: 200px;float: left;margin-left: 1%;padding: 10px;color: #9399a5;font-size: 14px;">
								基本信息
							</div>
							<div style="width: 30%;height: 200px;float: left;margin-left: 1%;">
								<ul class="qbb" style="list-style: none;margin: 0px;padding: 0px;padding-top: 10px;">
									<li><span
											style="font-size: 14px;color: #9399a5;">建造时间：</span><span>{{contents.zj_time}}</span>
									</li>
									<li><span
											style="font-size: 14px;color: #9399a5;">$造价:</span><span>{{contents.price}}</span>
									</li>
									<li><span style="font-size: 14px;color: #9399a5;">船型:</span></li>
									<li><span
											style="font-size: 14px;color: #9399a5;">总吨(t):</span><span>{{contents.all_weight}}</span>
									</li>
									<li><span
											style="font-size: 14px;color: #9399a5;">净吨(t):</span><span>{{contents.sell_weight}}</span>
									</li>
									<li><span
											style="font-size: 14px;color: #9399a5;">载重吨(t):</span>{{contents.zz_weight}}
									</li>
								</ul>
							</div>
							<div style="width: 30%;height: 200px;float: left;margin-left: 5%;">
								<ul class="qbb" style="list-style: none;margin: 0px;padding: 0px;padding-top: 10px;">
									<li><span style="font-size: 14px;color: #9399a5;">交付时间：</span>{{contents.jf_time}}
									</li>
									<li><span
											style="font-size: 14px;color: #9399a5;">IMO/编号:</span><span>{{contents.imo}}</span>
									</li>
									<li><span
											style="font-size: 14px;color: #9399a5;">长m:</span><span>{{contents.length}}</span>
									</li>
									<li><span
											style="font-size: 14px;color: #9399a5;">宽m:</span><span>{{contents.width}}</span>
									</li>
									<li><span
											style="font-size: 14px;color: #9399a5;">吃水m:</span><span>{{contents.water}}</span>
									</li>
									<li><span
											style="font-size: 14px;color: #9399a5;">航速/节:</span><span>{{contents.hs}}</span>
									</li>
								</ul>
							</div>
						</div>
					</div>
<!--					<div style="width: 95%;margin: 0 auto;height: 100px;margin-top: 20px;">-->
<!--						&lt;!&ndash; <Xguanyuedu></Xguanyuedu> &ndash;&gt;-->
<!--						&lt;!&ndash; 打赏分享 &ndash;&gt;-->
<!--						&lt;!&ndash; <tabmore :price="0" nologin_type="xptj" name="新品推荐" :tid="$route.query.id"></tabmore> &ndash;&gt;-->
<!--						<div @click="sca"-->
<!--							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 35%;">-->
<!--							<img class="scname" src="../../../imges/dsdsdsds/shoucang1.png"-->
<!--								style="width: 100%;height: 50px;" alt="">-->
<!--							<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">-->
<!--								收藏-->
<!--							</div>-->
<!--						</div>-->
<!--						<div @click="getShareInfo"-->
<!--							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 20px;">-->
<!--							<img class="scname" src="../../../imges/dsdsdsds/weixin1.png"-->
<!--								style="width: 100%;height: 50px;" alt="">-->
<!--							<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">-->
<!--								微信-->
<!--							</div>-->
<!--						</div>-->
<!--						<div @click="fxkj"-->
<!--							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 20px;">-->
<!--							<img class="scname" src="../../../imges/dsdsdsds/qqkongjian1.png"-->
<!--								style="width: 100%;height: 50px;" alt="">-->
<!--							<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">-->
<!--								空间-->
<!--							</div>-->
<!--						</div>-->
<!--						<div @click="das"-->
<!--							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 20px;border-radius: 50%;">-->
<!--							<img class="scname" src="../../../imges/dsdsdsds/dashang1.png"-->
<!--								style="width: 100%;height: 50px;" alt="">-->
<!--							<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">-->
<!--								打赏-->
<!--							</div>-->
<!--						</div>-->
<!--					</div>-->
					<!-- <div style="width: 95%;margin: 0 auto;height: 140px;border-top: 1px dashed #ddd;">
						<div
							style="width: 200px;height: 50px;margin: 15px auto;font-size: 20px;background-color: #D7230C;color: #FFF;text-align: center;line-height: 50px;">
							高清图片下载
						</div>
					</div> -->
				</div>
				<!-- 侧边栏 -->
				<div class="top_bottom_B">
<!--					<rightlist style="height: 496px;overflow: hidden;"></rightlist>-->

					<div
						style="height: 50px;background-color: red;line-height: 50px;color: #FFF;font-size: 20px;font-weight: 800;padding-left: 10px;margin-top: 10px;">
						相关设备
					</div>
					<div
						style="max-height: 550px;border: 1px solid #f0f0f0;box-sizing: border-box;overflow: scroll;min-height: 200px;">
						<div style="height: 60px;border-bottom: 1px solid #f0f0f0;" v-for="(item,index) in gys"
							:key="index">
							<div style="height: 15px;line-height: 15px;font-size: 12px;">
								品牌:&nbsp;&nbsp;{{item.unit_name}}</div>
							<div style="height: 15px;line-height: 15px;font-size: 12px;">
								设备名称:&nbsp;&nbsp;{{item.equipment_name}}</div>
							<div style="height: 15px;line-height: 15px;font-size: 12px;">
								联系方式:&nbsp;&nbsp;{{item.iphone}}</div>
							<div style="height: 15px;line-height: 15px;font-size: 12px;">数量:&nbsp;&nbsp;{{item.counts}}
							</div>
						</div>
					</div>
					<div @click="isShow = true"
						style="height: 30px;width: 40%;margin: 0 auto;line-height: 30px;color: #FFF;font-size: 20px;font-weight: 800;margin-top: 10px;text-align: center;background-color: red;">
						申请展示
					</div>
				</div>
			</div>
		</div>
		<!-- 中间结束 -->
		<!-- 尾标签 -->
<!--		<myfooter></myfooter>-->

		<!-- 遮罩层 -->
		<div v-show="isShow" style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;background: rgba(0, 0, 0, 0.8);">
			<div style="width: 500px;height: 40%;background-color: #FFF;margin: 0 auto;margin-top: 20%;">
				<div style="height: 30px;position: relative;border-bottom: 1px solid #6e6e6e;">
					<div style="font-size: 24px;line-height: 30px;position: absolute;right: 20px;"
						@click="isShow = false">
						X
					</div>
				</div>
				<div style="width: 80%;height: 70%;margin: 0 auto;">
					<div style="height: 30px;width: 80%;margin: 5px auto;">
						<span>品牌&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><input type="text"
							v-model="form.dwmc" />
					</div>
					<div style="height: 30px;width: 80%;margin: 5px auto;">
						设备名称 <input type="text" v-model="form.sbmc" />
					</div>
					<div style="height: 30px;width: 80%;margin: 5px auto;">
						联系方式 <input type="text" v-model="form.lxhm" />
					</div>
					<div style="height: 30px;width: 80%;margin: 5px auto;">
						<span>数量&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> <input type="text"
							v-model="form.sl" />
					</div>
					<div @click="fb"
						style="height: 30px;width: 100px;background-color: #D7230C;line-height: 30px;text-align: center;color: #FFF;font-size: 18px;font-weight: 800;margin: 5px auto;">
						发布
					</div>
				</div>
			</div>
		</div>
<!--		<dashang ref="child" :dsje="dsje"></dashang>-->
		<div class="popContainer" v-show="isShowQR" @click="gbgb">
			<vue-qr style="display: inline-block;
		position: absolute;
		top: 40%;
		left: 40%;" :logoSrc="imageUrl" :text="Text" :size="200"></vue-qr>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	import vueQr from 'vue-qr'
	export default {
		data() {
			return {
				form: {
					dwmc: '',
					sbmc: '',
					lxhm: '',
					sl: ''
				},
				options: [],
				imageUrl: 'https://img1.baidu.com/it/u=3311948344,2093308219&fm=253&fmt=auto&app=138&f=PNG?w=500&h=500',
				Text: '',
				isShowQR: false, //二维码显示
				letData: true,
				searchData: {
					type: '职位',
					keyword: '' //搜索框查询关键字
				},
				value: '',
				id: this.$route.query.id,
				title: this.$route.query.title,
				mid: this.$route.query.mid,
				kspa: false,
				ktpa: true,
				kvra: false,
				contents: '',
				gys: '',
				dsje: [{
					tid: this.$route.query.id,
					nologin_type: 'cbcx',
					name: '船舶船型打赏',
					price: 0,
				}],
				isShow: false,
			}
		},
		methods: {
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleDateString().replace(/:\d{1,2}$/, ' ');
			},
			gbgb() {
				this.isShowQR = false
				// $('#qrCodeUrl').html = ''
			},
			ksp() {
				this.ktpa = false
				this.kspa = true
				this.kvra = false
			},
			kvr() {
				this.ktpa = false
				this.kspa = false
				this.kvra = true
			},
			ktp() {
				this.ktpa = true
				this.kspa = false
				this.kvra = false
			},
			fxkj() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					const share = {
						title: this.contents.title,
						desc: "海工人|船海智造360°综合服务平台",
						image_url: [this.contents.picture],
						share_url: "https://www.shipoe360.com/#" + this.$route.path + '?id=' + this.id
					};
					//跳转地址
					location.replace(
						"https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
						encodeURIComponent(share.share_url) +
						"&title=" +
						share.title +
						"&pics=" +
						share.image_url.join("|") +
						"&summary=" +
						share.desc
					);
				} else {
					this.$router.replace('/login')
				}
			},
			getShareInfo() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					if (this.letData) {
						let myhref = window.location.href
						console.log(myhref)
						this.Text = myhref
						this.isShowQR = true
						this.letData = false
					} else {
						this.isShowQR = true
					}
				} else {
					this.$router.replace('/login')
				}
			},
			async sca() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					let res = await http.post('api/picture/personal_collection', {
						uid: loginInfo.id,
						title: this.contents.title,
						picture: this.contents.picture,
						pc_link: this.$route.path + '?id=' + this.id + '&title=' + this.title,
						url_link: 'pages/shipseadetails/index?id=' + this.id,
					})
					if (res.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '收藏成功',
							type: 'success'
						});
					} else {
						this.$notify({
							title: '失败',
							message: res.data.msg,
							type: 'error'
						});
					}
				} else {
					this.$router.replace('/login')
				}

			},
			das() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					this.$refs.child.isShowZF = true //修改子组件data
				} else {
					this.$router.replace('/login')
				}
			},
			async fb() {
				let res2 = await http.post('api/picture/supplier_add', {
					lscx_id: this.id,
					unit_name: this.form.dwmc,
					equipment_name: this.form.sbmc,
					iphone: this.form.lxhm,
					counts: this.form.sl
				})
				if (res2.data.code == 200) {
					this.isShow = false
					this.$notify({
						title: '成功',
						message: '添加成功',
						type: 'success'
					});
					this.form.dwmc = ''
					this.form.sbmc = ''
					this.form.lxhm = ''
					this.form.sl = ''
					this.lonsb()
				}
			},
			async lonsb() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				// console.log(loginInfo)
				let res1 = await http.post('api/picture/historical_ship_detail', {
					id: this.id,
					// uid:loginInfo.id
				})
				console.log(res1)

				this.contents = res1.data.data.list
				this.gys = res1.data.data.list.supplier
			},
			fha() {
				console.log('返回上一层')
				this.$router.go(-1); //返回上一层
			},
		},
		async mounted() {
			const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
			let res = await http.get('index.php/bscard/wxapp.Sorts')
			this.options = res.data.data

			this.lonsb()

		},
		components: {
			// 尾标签,
			myfooter: resolve => require(['@/components/myfooter'], resolve),
			vueQr,
			// 头标签
			dpubtop: resolve => require(['@/components/dpubtop/dpubtop'], resolve),
			//测标签
			rightlist: resolve => require(['@/components/dpubtop/rightList.vue'], resolve),
			//广澳
			PCguangao: resolve => require(['@/components/dpubtop/PCguangao.vue'], resolve),
			//相关阅读
			Xguanyuedu: resolve => require(['@/components/dpubtop/xgyd.vue'], resolve),
			dashang: resolve => require(['@/components/dashang/dashang.vue'], resolve),
		}
	}
</script>

<style scoped>
	.centert {
		width: 1200px;
		margin: 0 auto;
	}

	.Bigcoffdetails {
		width: 100%;
	}

	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
		height: 36px;
	}

	.pub_title {
		width: 350px;
		float: left;
	}

	.ctu_::after,
	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.pub_title>img {
		width: 100%;
		height: 100%;
	}

	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	.qbb>li {
		margin-top: 5px;
	}

	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	.sm_pub {
		float: left;
		margin-left: 12px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	.sy::after,
	.ckgd_dh::after {
		content: '';
		display: block;
		clear: both;
	}

	.ckgd_dh {
		float: left;
		font-size: 12px;
		margin-left: 50px;
	}

	.ckgd_dh>div {
		float: left;
		height: 40px;
		line-height: 42px;
		color: #5e5d5d;
	}


	.name {
		line-height: 43px;
	}

	.sy_img {
		float: left;
		width: 20px;
		height: 20px;
	}

	.sy_img>img {
		margin-top: 13px;
		width: 100%;
		height: 100%;
	}

	.jt>img {
		margin-top: 10px;
	}

	.sy_title {
		float: left;
		height: 40px;
		line-height: 44px;
		margin-left: 6px;
		color: #5e5d5d;
	}

	.jt {
		width: 12px;
		height: 20px;
		margin-left: 6px;
		margin-right: 6px;
	}


	/* 头部结束 */
	.top_bottom {
		width: 100%;
		/* height: 1150px; */
		clear: both;
		overflow: hidden;
		height: 100%;
		box-shadow: #6e6e6e 0px 0px 10px;
		margin-top: 30px;
	}

	.top_bottom_T {
		width: 80%;
		/* height: 1150px; */
		float: left;
	}

	.top_bottom_B {
		width: 20%;
		/* height: 1150px; */
		float: left;
	}

	.dtiail_warp {
		width: 95%;
		margin: 0 auto;
	}

	.dtiail_title {
		margin-top: 40px;
		margin-bottom: 16px;
		text-align: center;
		font-size: 22px;
		color: #c00e0e;
	}

	.cont_dtiail>>>p>>>img {
		width: auto;
		height: 100%;
	}

	.cont_dtiail {
		overflow: hidden;
		margin-top: 20px;
		min-height: 300px;
	}

	/* 遮罩层 */
	.popContainer {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 999;
		background: rgba(0, 0, 0, 0.6);
	}
</style>
